import React from "react";
import { Button } from "react-bootstrap";
import { IModal } from "../../interfaces/Components/Modal/IModal";
import FocusTrap from "focus-trap-react";
import "./modal.scss";

export const Modal: React.FC<IModal> = ({title, show, closeOnClickAway = true, closeEvent, children}) => {
  const backdropClassName = `backdrop ${!show ? 'hidden' : ''}`;

  const closeHandler = () => {
    if(closeOnClickAway) closeEvent();
  };

  return(
    <FocusTrap>
      <div role="dialog" aria-modal="true" className="modal" aria-label={title}>
        <div className={backdropClassName} onClick={closeHandler}></div>

        <div className="modal-content" data-testid="modal-content">
          <div className="modal-header">
            <div className="modal-title h4">{title}</div>
            <Button className="btn-close" onClick={closeEvent} aria-label="Close"/>
          </div>
          <div className="modal-body">
            {children}
          </div>
        </div>
      </div>
      </FocusTrap>
  );
};